import React from "react";
import { useTheme } from "@mui/material";
import MuiPaper, { PaperProps as MuiPaperProps } from "@mui/material/Paper";
import Stack from "@mui/material/Stack";
import { CountUp } from "../CountUp";
import Typography from "@mui/material/Typography";
import CircularProgress from "@mui/material/CircularProgress";

type PaperProps = MuiPaperProps & {
  label: string;
  end?: number;
  start?: number;
  icon?: React.ReactNode;
  loading?: boolean;
  prefix?: string;
  suffix?: string;
  decimals?: number;
};

export function Paper({
  icon,
  start = 0,
  end = 0,
  label,
  loading,
  prefix = "",
  suffix = "",
  decimals,
  ...rest
}: PaperProps) {
  const theme = useTheme();

  return (
    <MuiPaper {...rest}>
      <Stack direction="row" spacing={4} alignItems="center">
        <>{icon}</>
        <Stack
          maxWidth="100%"
          overflow="hidden"
          textOverflow="ellipsis"
          spacing={1}
          alignItems="center"
        >
          {loading ? (
            <Stack justifyContent="center" alignItems="center">
              <CircularProgress
                size={theme.typography.h5.fontSize}
                thickness={4}
              />
            </Stack>
          ) : (
            <CountUp
              fontSize="1.4vw"
              fontWeight={600}
              color="primary"
              start={start}
              end={end}
              prefix={prefix}
              suffix={suffix}
              decimals={decimals}
            />
          )}

          <Typography noWrap variant="subtitle1" color="GrayText">
            {label}
          </Typography>
        </Stack>
      </Stack>
    </MuiPaper>
  );
}
